export default "__VITE_ASSET__97b3ed69__$_?nuxt_component=async__"